import React from "react";
import "./idSeparator.css";
import smallIdseparatorIcon from "../assets/small-id-logo.svg";
import largeIdseparatorIcon from "../assets/id-logo-burger-menu.svg";
import { Divider } from "primereact/divider";
import { IdSeparatorProps } from "../types/IdSeparatorProps";

export const IdSeparator = ({ useLargeLogo }: IdSeparatorProps) => {
    return (
        <div
            style={{
                marginTop: useLargeLogo ? "1.5rem" : "",
                marginBottom: useLargeLogo ? "1rem" : ""
            }}
            className={`id-separator id-separator_${
                useLargeLogo ? "large" : "small"
            }`}
        >
            <img
                src={useLargeLogo ? largeIdseparatorIcon : smallIdseparatorIcon}
            />
            <Divider />
        </div>
    );
};
